<template>
        <div>
            <h2>Hanami est une collection de flash cards centrée sur des questions autour du réchauffement climatique, de la transition énergétique et de l'écologie en général.</h2>
            <h2>Bon il n'y a pas encore de cartes pour le moment, mais promis, elles arrivent bientôt !</h2>
            <h2>Alors n'hésite pas à revenir souvent et à nous donner ton avis par mail à dummyemail[at]bottrad.com</h2>
            <h2 @click="previous">Retour au menu</h2>
        </div>
</template>

<script>
    export default {
        name: "About",
        props: ["previous"]
    }
</script>

<style scoped>
    h2 {
        font-size: 1em;
        padding: 5%;
        text-indent: 0;
        text-align: justify;
    }
</style>